const normalizeUuid = (value) => {
  if (typeof value === 'object' && value?.uuid) {
    return value.uuid
  }

  if (typeof value !== 'string') {
    return null
  }

  return value.split('/').filter(Boolean).pop() || null
}

export const orderResourcesByUuid = (resources, order = []) => {
  if (!Array.isArray(resources) || !Array.isArray(order) || !order.length) {
    return Array.isArray(resources) ? resources : []
  }

  const positions = new Map(order.map((uuid, index) => [uuid, index]))

  return resources
    .map((resource, index) => ({ resource, index }))
    .sort((left, right) => {
      const leftPosition = positions.get(normalizeUuid(left.resource)) ?? Number.MAX_SAFE_INTEGER
      const rightPosition = positions.get(normalizeUuid(right.resource)) ?? Number.MAX_SAFE_INTEGER

      return leftPosition - rightPosition || left.index - right.index
    })
    .map(({ resource }) => resource)
}
